import { createContext,useEffect, useReducer, useState } from "react";
import { useContext } from "react";
import { AuthContext } from "./AuthContext";
// import { Chat } from "../config/firebase";
// import { onChatStateChanged } from "firebase/Chat";

export const ChatContext = createContext();

export const ChatContextProvider = ( {children}) =>{
  const {currentuser} = useContext(AuthContext);
    const initialState = {
      chatId: "null",
      user:{},
    };

    const chatReducer = (state, action) =>{
      switch(action.type){
        case "CHANGE_USER":
          return {
            user : action.payload,
            chatId: currentuser.uid > action.payload.uid
             ? currentuser.uid+ action.payload.uid  
             : action.payload.uid + currentuser.uid
          };

        default:
          return state;
      }
    };

    const [state, dispatch] = useReducer(chatReducer, initialState)

    return(
  <ChatContext.Provider value={{data:state, dispatch}}>
    {children}
  </ChatContext.Provider>
    );
};